<template>
  <div>
    <Map ref="map" class="species-map" style="height: 360px" :zoom="zoom" :options="{ minZoom: 1 }" @loaded="mapLoaded" @update:zoom="updateZoom">
      <SpeciesMapLayer :detections.sync="highlightedDetections" :species="species" :zoom="zoom" @load="stationsLoaded" />
    </Map>

    <div class="row species-row">
      <div class="col-xl">
        <TopDetections :species="species" />
      </div>

      <div class="col-latest-detections">
        <LatestDetections :detections="allDetections" :loading="$apollo.queries.detections.loading" />
      </div>
    </div>
  </div>
</template>

<script>
import LatestDetections from './components/LatestDetections'
import Map from 'components/Map'
import SpeciesMapLayer from './components/SpeciesMapLayer'
import TopDetections from './components/TopDetections'

import ExploreDetectionsQuery from 'queries/ExploreDetections.graphql'
import NewDetectionsQuery from 'queries/NewDetections.graphql'

export default {
  props: {
    species: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      zoom: 2,

      detections: {},
      liveDetections: [],

      highlightedDetections: []
    }
  },

  methods: {
    mapLoaded () {
      this.$refs.map.createPane('species')
      this.$refs.map.createPane('stations')
    },

    updateZoom (zoom) {
      this.zoom = zoom
    },

    stationsLoaded (stations) {
      if (stations.length) {
        this.$refs.map.fitBounds(stations.map(({ station }) => [station.coords.lat, station.coords.lon]))
      }
    },

    newDetection (detection) {
      if (detection.speciesId == this.species.id) {
        this.liveDetections.unshift(detection)
        this.highlightedDetections.unshift(detection)
      }
    }
  },

  computed: {
    allDetections () {
      return [...this.liveDetections, ...this.detections.nodes || []].slice(0, 20)
    },

    queryVariables () {
      return {
        speciesIds: [this.species.id]
      }
    }
  },

  apollo: {
    detections: {
      query: ExploreDetectionsQuery,
      fetchPolicy: "network-only",

      variables () {
        return {
          first: 20,
          period: { unit: 'month', count: 1 },
          uniqueStations: true,
          ...this.queryVariables
        }
      }
    },

    $subscribe: {
      newDetection: {
        query: NewDetectionsQuery,

        result ({ data }) {
          if (data.newDetection) {
            const detection = data.newDetection.detection
            this.newDetection(detection)
          }
        }
      }
    }
  },

  components: {
    LatestDetections,
    Map,
    SpeciesMapLayer,
    TopDetections
  }
}
</script>
